import type { PreflightIssue } from '../../lib/start-preflight.ts';

/**
 * Why Start was refused when a stage ahead cannot resolve its configuration.
 *
 * A panel rather than a toast because the list is the work: each row names the stage and the
 * setting that stops it, and the person fixes those in Settings or the ticket's overrides before
 * pressing Start again. Nothing here offers "start anyway" -- a stage that cannot resolve would
 * only park the ticket later, after the refinement had been paid for.
 */
export function StartPreflightPanel({ issues, onClose }: { issues: readonly PreflightIssue[]; onClose: () => void }) {
  return (
    <section className="drawer-depblock is-unavailable" aria-label="Start refused: configuration does not resolve">
      <div className="drawer-depblock-head">
        <span className="drawer-depblock-kicker">Not started: configuration does not resolve</span>
        <button type="button" className="btn btn-sm" onClick={onClose}>
          Close
        </button>
      </div>
      <ul className="drawer-depblock-list">
        {issues.map((issue, index) => (
          <li key={`${issue.stage}-${index}`} className="drawer-depblock-row">
            <span className="mono">{issue.stage}</span>
            <span className="dim">{issue.reason}</span>
          </li>
        ))}
      </ul>
      <p className="drawer-depblock-meta">
        Fix these in Settings or the ticket&apos;s overrides, then press Start again. A machine that is only offline,
        paused or signed out does not stop a start.
      </p>
    </section>
  );
}
